export class QueryDBStatusResponse {
    'runningTimeMs';
    'status';
    'errorMessage';
    'outputLocations';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runningTimeMs",
            "baseName": "runningTimeMs",
            "type": "number",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "QueryDBStatus",
            "format": ""
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "outputLocations",
            "baseName": "outputLocations",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryDBStatusResponse.attributeTypeMap;
    }
    constructor() {
    }
}
